export default "__VITE_ASSET__D7$2W8Km__"